import {
  type Actions,
  ImmerReducer,
  createActionCreators,
  createReducerFunction,
} from "immer-reducer";

import type { IOLOState, IOrderDetail, IPreorder } from "types/olo";
import { RequestStatus } from "types/request";

export class OLOReducer extends ImmerReducer<IOLOState> {
  public receivePreorders(preorders: IPreorder[]) {
    this.draftState.preorders = preorders;
    // Remove any cached order details. Order numbers are not unique across restaurants.
    this.draftState.preorderDetails = {};
  }
  public receivePreorderDetail(orderNumber: number, orderDetail: IOrderDetail) {
    this.draftState.preorderDetails[orderNumber] = orderDetail;
  }
  public setListRequestStatus(status: RequestStatus) {
    this.draftState.requestStatus.preorders = status;
  }
  public setDetailsRequestStatus(orderNumber: number, status: RequestStatus) {
    this.draftState.requestStatus.preorderDetails[orderNumber] = status;
  }
}

const initialState: IOLOState = {
  preorders: [],
  preorderDetails: {},
  requestStatus: {
    preorders: RequestStatus.NOT_STARTED,
    preorderDetails: {},
  },
};

export default createReducerFunction(OLOReducer, initialState);
export const ActionCreators = createActionCreators(OLOReducer);
export type OLOActions = Actions<typeof OLOReducer>;
